import React, { useState, useEffect } from 'react';
import Button from 'components/Button';
import TextField from 'components/TextField';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import LogoImage from 'assets/images/logo.png';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Divider from '@material-ui/core/Divider';
import moment from 'moment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import {
  Container,
  ProductInformation,
  Update,
  CloudWrapper,
  Wrapper,
} from 'styles/pages/edit-products/editProductInformation';
import { Heading } from 'styles/pages/edit-products/editProductSizes';

const isImageValid = (url) =>
  url?.includes('.png') || url?.includes('.jpeg') || url?.includes('.jpg');

const openCloudinaryWidget = (folder, cb) => {
  const myWidget = window.cloudinary.createUploadWidget(
    {
      cloudName: 'big-oven-tees-inc',
      uploadPreset: 'tnedst8q',
      folder,
    },
    (error, result) => {
      if (!error && result && result.event === 'success') {
        cb(result?.info?.secure_url);
        myWidget.close();
      }
    }
  );
  myWidget.open();
};

const EditColorInformation = ({
  product = { Product: {} },
  editColorsInformation,
}) => {
  const [colors, setColors] = useState(product?.Colors);
  const disabled = !!colors?.filter((c) => !c?.Name || !c?.HexCode)?.length;
  const printAreas = product?.PrintAreas?.filter(
    (p) => !(p?.printAreaName === 'Front' || p?.printAreaName === 'Back')
  );

  return (
    <Container>
      <ProductInformation>
        <Heading style={{ marginBottom: 30 }}>
          <h3 style={{ border: 'none' }}>Product Colors</h3>
          <IconButton
            aria-label='delete'
            color='secondary'
            onClick={() =>
              setColors([
                ...colors,
                {
                  Name: '',
                  HexCode: '',
                  Image: '',
                  BackImage: '',
                  ID: moment().unix() + colors?.length,
                  visible: true,
                },
              ])
            }>
            <AddCircleIcon style={{ fontSize: 30 }} />
          </IconButton>
        </Heading>

        {colors?.map((color, index) => (
          <Wrapper
            key={`EditProductColors${index}`}
            style={{
              borderBottom: '1px solid #000',
              paddingBottom: 10,
              marginBottom: 40,
              flexDirection: 'column',
            }}>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '23px 1fr 1fr 23px',
                width: '100%',
                gridGap: '30px',
                alignItems: 'center',
                marginBottom: '20px',
              }}>
              {color?.visible === false ? (
                <VisibilityOffIcon
                  style={{ color: 'red', cursor: 'pointer', marginRight: 20 }}
                  onClick={() => {
                    setColors(
                      colors?.map((s, i) => {
                        if (i !== index) {
                          return s;
                        }
                        return {
                          ...s,
                          visible: true,
                        };
                      })
                    );
                  }}
                />
              ) : (
                <VisibilityIcon
                  style={{
                    color: 'lightseagreen',
                    cursor: 'pointer',
                    marginRight: 20,
                  }}
                  onClick={() => {
                    setColors(
                      colors?.map((s, i) => {
                        if (i !== index) {
                          return s;
                        }
                        return {
                          ...s,
                          visible: false,
                        };
                      })
                    );
                  }}
                />
              )}

              <TextField
                label='Name'
                size='small'
                value={color?.Name || ''}
                onChange={(Name) => {
                  setColors(
                    colors?.map((s, i) => {
                      if (i !== index) {
                        return s;
                      }
                      return {
                        ...s,
                        Name,
                      };
                    })
                  );
                }}
              />
              <TextField
                label='Color'
                size='small'
                type='color'
                value={color?.HexCode || ''}
                onChange={(HexCode) => {
                  setColors(
                    colors?.map((s, i) => {
                      if (i !== index) {
                        return s;
                      }
                      return {
                        ...s,
                        HexCode,
                      };
                    })
                  );
                }}
              />

              <IconButton
                aria-label='delete'
                disabled={!colors?.length}
                onClick={() => setColors(colors?.filter((s, i) => i != index))}>
                <DeleteIcon color='secondary' />
              </IconButton>
            </div>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr',
                width: '100%',
                gridGap: '30px',
                alignItems: 'center',
                marginBottom: '20px',
              }}>
              <CloudWrapper>
                <img
                  src={isImageValid(color?.Image) ? color?.Image : LogoImage}
                />
                <TextField
                  label='Image'
                  size='small'
                  value={color?.Image || ''}
                  onChange={(Image) => {
                    setColors(
                      colors?.map((s, i) => {
                        if (i !== index) {
                          return s;
                        }
                        return {
                          ...s,
                          Image,
                        };
                      })
                    );
                  }}
                />
                <CloudUploadIcon
                  onClick={() => {
                    openCloudinaryWidget(
                      `Shirtly/Shirtly_Products_Mock/Images/mockups/${product?.Product?.Name}`,
                      (Image) => {
                        setColors(
                          colors?.map((s, i) => {
                            if (i !== index) {
                              return s;
                            }
                            return {
                              ...s,
                              Image,
                            };
                          })
                        );
                      }
                    );
                  }}
                />
              </CloudWrapper>
              <CloudWrapper>
                <img
                  src={
                    isImageValid(color?.BackImage)
                      ? color?.BackImage
                      : LogoImage
                  }
                />
                <TextField
                  label='Back Image'
                  size='small'
                  value={color?.BackImage || ''}
                  onChange={(BackImage) => {
                    setColors(
                      colors?.map((s, i) => {
                        if (i !== index) {
                          return s;
                        }
                        return {
                          ...s,
                          BackImage,
                        };
                      })
                    );
                  }}
                />
                <CloudUploadIcon
                  onClick={() => {
                    openCloudinaryWidget(
                      `Shirtly/Shirtly_Products_Mock/Images/mockups/${product?.Product?.Name}`,
                      (BackImage) => {
                        setColors(
                          colors?.map((s, i) => {
                            if (i != index) {
                              return s;
                            }
                            return {
                              ...s,
                              BackImage,
                            };
                          })
                        );
                      }
                    );
                  }}
                />
              </CloudWrapper>

              {printAreas?.map((p, x) => (
                <CloudWrapper key={`PrintAreaColor${x}`}>
                  <img
                    src={
                      isImageValid(color?.[`${p?.printAreaName}Image`])
                        ? color?.[`${p?.printAreaName}Image`]
                        : LogoImage
                    }
                  />
                  <TextField
                    label={`${p?.printAreaName} Image`}
                    size='small'
                    value={color?.[`${p?.printAreaName}Image`] || ''}
                    onChange={(image) => {
                      setColors(
                        colors?.map((s, i) => {
                          if (i !== index) {
                            return s;
                          }
                          return {
                            ...s,
                            [`${p?.printAreaName}Image`]: image,
                          };
                        })
                      );
                    }}
                  />
                  <CloudUploadIcon
                    onClick={() => {
                      openCloudinaryWidget(
                        `Shirtly/Shirtly_Products_Mock/Images/mockups/${product?.Product?.Name}`,
                        (image) => {
                          setColors(
                            colors?.map((s, i) => {
                              if (i !== index) {
                                return s;
                              }
                              return {
                                ...s,
                                [`${p?.printAreaName}Image`]: image,
                              };
                            })
                          );
                        }
                      );
                    }}
                  />
                </CloudWrapper>
              ))}
            </div>
          </Wrapper>
        ))}

        <Divider />
      </ProductInformation>

      <Update>
        <Button
          disabled={disabled}
          title='Update'
          onClick={() => {
            const payload = {
              ID: product?.Product?.ID,
              colorsData: colors,
            };

            editColorsInformation(payload);
          }}
        />
      </Update>
    </Container>
  );
};

export default EditColorInformation;
